import { render, staticRenderFns } from "./opnamefrm.vue?vue&type=template&id=0584e4ad"
import script from "./opnamefrm.vue?vue&type=script&lang=js"
export * from "./opnamefrm.vue?vue&type=script&lang=js"
import style0 from "./opnamefrm.vue?vue&type=style&index=0&id=0584e4ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports